const DeactivateIcon = ({
  height = "40px",
  width = "40px",
}: {
  height?: string;
  width?: string;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{ width: `${width}`, height: `${height}` }} // Use inline styles here
      viewBox="0 0 40 40"
      fill="none"
    >
      <path
        d="M0 8C0 3.58172 3.58172 0 8 0H32C36.4183 0 40 3.58172 40 8V32C40 36.4183 36.4183 40 32 40H8C3.58172 40 0 36.4183 0 32V8Z"
        fill="#E9EEFE"
      />
      <path
        d="M20.2273 28.6665C19.3904 27.6351 18.8889 26.3205 18.8889 24.8887C18.8889 23.2554 19.5415 21.7745 20.6003 20.6926C17.262 20.3061 13.8344 20.9239 10.782 22.5459C10.3008 22.8016 10 23.3021 10 23.847V27.111C10 27.97 10.6965 28.6665 11.5556 28.6665H20.2273Z"
        fill="#183883"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.6666 10C16.0893 10 14 12.0893 14 14.6666C14 17.244 16.0893 19.3334 18.6666 19.3334C21.2439 19.3334 23.3332 17.244 23.3332 14.6666C23.3332 12.0893 21.2439 10 18.6666 10Z"
        fill="#183883"
      />
      <path
        d="M25.0775 20C22.278 20 20 22.278 20 25.0775C20 27.877 22.2769 30.1562 25.0775 30.1562C27.8782 30.1562 30.1551 27.8782 30.1551 25.0787C30.1551 22.2792 27.877 20 25.0775 20ZM26.997 25.8931C27.3017 26.1978 27.3017 26.6923 26.997 26.9982C26.6923 27.3028 26.1978 27.3028 25.892 26.9982L25.0775 26.1837L24.2631 26.9982C23.9584 27.3028 23.4639 27.3028 23.1581 26.9982C22.8534 26.6935 22.8534 26.199 23.1581 25.8931L23.9725 25.0787L23.1581 24.2643C22.8534 23.9596 22.8534 23.4651 23.1581 23.1593C23.4628 22.8534 23.9573 22.8546 24.2631 23.1593L25.0775 23.9737L25.892 23.1593C26.1966 22.8546 26.6911 22.8546 26.997 23.1593C27.3028 23.4639 27.3017 23.9584 26.997 24.2643L26.1826 25.0787L26.997 25.8931Z"
        fill="#E62D38"
      />
    </svg>
  );
};
export default DeactivateIcon;
